import React, { useState } from "react";

function DropDownGPTMulti({
  label,
  items = [],
  value = [],
  onChange,
  className,
  mandatory = false,
}) {
  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  // Filter items based on the input query
  const filteredItems = items.filter((item) =>
    item.label.toLowerCase().includes(query.toLowerCase())
  );

  const handleSelect = (selectedItem) => {
    const isSelected = value.some((item) => item === selectedItem.value);
    const newSelectedItems = isSelected
      ? value.filter((item) => item !== selectedItem.value)
      : [...value, selectedItem.value];
    onChange(newSelectedItems);
  };

  return (
    <div className={`relative ${className}`}>
     
      <div
        className="mt-1 relative"
        onFocus={() => setIsOpen(true)}
        onBlur={() => setIsOpen(false)}
      >
        <input
          type="text"
          className={`w-full px-3 py-1 cursor-pointer text-black border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-blue-300 focus:border-blue-300 focus:border-2 sm:text-sm  ${mandatory && value.length === 0 ? "border-red-500" : ""}`}
          placeholder={label}
          value={items
            .filter((item) => value.some((selected) => selected === item.value))
            .map((item) => item.label)
            .join(", ")}
          onChange={(e) => setQuery(e.target.value)}
          onClick={() => setIsOpen(true)}
          readOnly // Make the input read-only to prevent typing
        />
        {isOpen && (
          <ul className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
            {filteredItems.map((item) => (
              <li
                key={item.value}
                className={`cursor-pointer select-none relative py-2 pl-3 pr-9 ${
                  value.some((selected) => selected === item.value)
                    ? "bg-blue-100 "
                    : "text-gray-900"
                }`}
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => handleSelect(item)}
              >
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={value.some((selected) => selected === item.value)}
                    onChange={() => handleSelect(item)}
                    className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                  />
                  <span className="ml-3 block truncate">{item.label}</span>
                </div>
              </li>
            ))}
            {filteredItems.length === 0 && (
              <li className="cursor-default select-none relative py-2 pl-3 pr-9 text-gray-500">
                Aucun résultat
              </li>
            )}
          </ul>
        )}
      </div>
    </div>
  );
}

export default DropDownGPTMulti;
